import { Link } from 'react-router-dom'
import './Nav.css'

export default function Nav() {
  return (
    <nav>
      <Link to="/" className="nav-logo">
        <div className="flex items-center justify-center h-8 w-8 rounded-lg bg-orken-accent text-[#0d1f12] text-xs font-extrabold">Ō</div>
        <div>
          <div className="nav-logo-text">Orken</div>
          <div className="nav-logo-sub">Tecnologia</div>
        </div>
      </Link>
      <div className="nav-links">
        <Link to="/">Início</Link>
        <Link to="/cases">Cases</Link>
        <Link to="/blog">Blog</Link>
        <a href="#setores">Setor Público</a>
        <a href="#setores">Setor Privado</a>
        <a href="#sobre">Sobre</a>
        <a href="#contato">Contato</a>
        <a href="https://wa.link/gptqwc" target="_blank" rel="noopener" className="nav-cta">Fale com a gente</a>
      </div>
    </nav>
  )
}
